import { render, staticRenderFns } from "./tousuindex.vue?vue&type=template&id=34cac5a0&"
import script from "./tousuindex.vue?vue&type=script&lang=js&"
export * from "./tousuindex.vue?vue&type=script&lang=js&"
import style0 from "./tousuindex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports